<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Podcast</h4>
            <h6>Manage Podcast</h6>
          </div>
        </div>
        <ul class="table-top-head">

          <li>
            <a ref="collapseHeader" data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse"
               @click="toggleCollapse(collapseHeader)">
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
        <div class="page-btn d-flex gap-1">
          <a @click="savePodcast()" href="javascript:void(0);" class="btn btn-added">
            <vue-feather type="plus-circle"
                         class="me-2"></vue-feather>
            Save</a>

          <router-link style="color: var(--PRIMARY-COLOR) !important;" :to="cancelRoute"
                       class="btn btn-added bg-white">
            <vue-feather type="x" class="me-2"></vue-feather>
            Cancel
          </router-link>
        </div>
      </div>

      <div class="card">
        <div class="card-body">

          <div class="row">
            <div class="col-sm">
              <BFormFloatingLabel> Title</BFormFloatingLabel>
              <BFormInput class="mb-3" v-model="podcast.title"/>
            </div>

            <div class="col-sm">
              <BFormFloatingLabel> Category</BFormFloatingLabel>
              <vue-select
                  :options="categories"
                  v-model="podcast.podcast_category_id"
                  placeholder="Choose Category"
                  class="mb-3"
              />
            </div>

            <div class="col-sm">
              <BFormFloatingLabel> Author </BFormFloatingLabel>
<!--              <BFormInput class="mb-3" v-model="podcast.author"/>-->
              <vue-select
                  :options="users"
                  v-model="podcast.author_id"
                  placeholder="Choose Author"
                  class="mb-3"
              />
            </div>


          </div>

          <div class="row">
            <div class="col-sm">
              <BFormFloatingLabel> Description</BFormFloatingLabel>
              <BFormTextarea class="mb-3" v-model="podcast.description" rows="4"/>
            </div>
          </div>

          <div class="row">

            <!-- Image thumbnail-->
            <div class="d-flex my-2" style="cursor: pointer;">
              <a-image :width="0" :style="{ display: 'none' }" :preview="{
              visible,
              onVisibleChange: setVisible,
            }" :src="imagePreviewUrl"/>

              <div v-if="imagePreviewUrl" class="image-container col-12 rounded" @mouseover="showOverlay = true"
                   @mouseleave="showOverlay = false">
                <img :src="imagePreviewUrl" alt="Preview"/>
                <div v-if="showOverlay" class="overlay">
                  <button @click="deleteImage" class="delete-btn">
                    <vue-feather type="trash-2"></vue-feather>
                  </button>
                  <button @click="openThumbnail(imagePreviewUrl)" class="zoom-btn">
                    <vue-feather type="zoom-in"></vue-feather>
                  </button>
                </div>
              </div>

              <div class="file-upload" v-else @click="openModal(false)">

                <span role="img" aria-label="plus" class="anticon anticon-plus"><svg focusable="false" data-icon="plus"
                                                                                     width="1em" height="1em"
                                                                                     fill="currentColor"
                                                                                     aria-hidden="true"
                                                                                     viewBox="64 64 896 896">
                  <path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"></path>
                  <path d="M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"></path>
                </svg><!----></span>
                <div class="file-upload-text">Upload</div>
              </div>
            </div>
            <!-- /Image thumbnail-->

           <!-- /Audio-->

            <div class="card">
              <div class="card-body">

                <div>
                  <h5>
                    Audio File
                  </h5>
                </div>

                <audio v-if="podcast.file" controls>
                  <source :src="audioPreviewUrl" type="audio/mpeg" />
                  Your browser does not support the audio tag.
                </audio>

                <div v-if="podcast.file" class="text-end">
                  <button class="btn btn-sm btn-outline-danger" @click="podcast.file = ''">Remove Audio</button>
                </div>

                <div class="file-upload my-4" v-else>
                  <input type="file" @change="handleFileUpload" accept="audio/*"/>

                  <span role="img" aria-label="plus" class="anticon anticon-plus">
                                    <svg focusable="false"
                                         data-icon="plus" width="1em"
                                         height="1em" fill="currentColor"
                                         aria-hidden="true"
                                         viewBox="64 64 896 896">
                                      <path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"></path>
                                      <path d="M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"></path>
                                    </svg><!----></span>
                  <div class="file-upload-text">Upload</div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <MediaModal
      ref="mediaModal"
      :media="media"
      :select-multiple="selectMultiple"
      @selected="handleMediaSelected"
  />

</template>

<script setup>
import { toggleCollapse } from "@/utils/components";
import { useRoute, useRouter } from "vue-router";
import { usePodcastStore } from "@/store/podcastStore";
import { useUserStore } from "@/store/userStore";
import { usePodcastCategoryStore } from "@/store/podcastCategoryStore";
import { computed, onMounted, ref } from "vue";
import { useMediaStore } from "@/store/mediaStore";
import MediaModal from "@/views/pages/modals/mediaModal.vue";

const podcastStore = usePodcastStore();
const categoryStore = usePodcastCategoryStore();
const mediaStore = useMediaStore();
const userStore = useUserStore();
const selectMultiple = ref(false)

const categories = computed(() =>
    categoryStore.podcastCategories.map(cat => ({
      text: cat.name,
      id: cat.id
    }))
);

const users = computed(() =>
    userStore.users.map(user => ({
      text: user.name,
      id: user.id
    }))
);

const audioPreviewUrl = computed(() => {
  if (!podcast.value.file) return null;
  return typeof podcast.value.file === "string"
      ? podcast.value.file
      : URL.createObjectURL(podcast.value.file);
});


// thumbnail control
const imagePreviewUrl = ref(null);
const showOverlay = ref(false);
const visible = ref(false);

function setVisible(val) {
  visible.value = val;
}

function previewImage(e) {
  const file = e.target.files[0];
  if (file) {
    imagePreviewUrl.value = URL.createObjectURL(file);
  }
}

function deleteImage() {
  imagePreviewUrl.value = null;
  podcast.value.media_item_id = '';
}

function openThumbnail(url) {
  imagePreviewUrl.value = url;
  visible.value = true;
}

const media = computed( ()=> mediaStore.media);

const route = useRoute();
const router = useRouter();
const action = route.params.action;
const encodedData = route.params.encodedData || null;

const cancelRoute = {name: "podcast-list"};

const podcast = ref({
  'title' : '',
  'podcast_category_id': '',
  // 'author': '',
  'description': '',
  'media_item_id': '',
  'file': '',
  'author_id': ''
});

function openModal( value ) {
  selectMultiple.value = value;
  $("#mediaModal").modal("show");
}

function handleMediaSelected(selected) {
  if (!selectMultiple.value) {
    imagePreviewUrl.value = selected[0]?.url || '';
    podcast.value.media_item_id = selected[0]?.id || '';
  }
}

function handleFileUpload(event) {
  const file = event.target.files[0];
  if (file) {
    podcast.value.file = file;
  }
}

function savePodcast()
{
  switch (action) {
    case "add":
      podcastStore.addPodcast(podcast.value).then((response) => {
        if (response) {
          router.push({name: "podcast-list"});
        }
      });
      break;
    case "edit":
      podcastStore
          .updatePodcast(podcast.value.id, podcast.value)
          .then((response) => {
            if (response) {
              router.push({name: "podcast-list"});
            }
          });
      break;
  }
}

onMounted(async () => {
  await categoryStore.fetchPodcastCategories();
  await mediaStore.fetchMedia();
  await userStore.fetchUsers({ is_author: 1 });

  if (action === "edit" && encodedData) {
    try {
      // Decode base64 and parse
      const decoded = JSON.parse(atob(encodedData));

      // Check if podcastId is present
      if (decoded.podcastId) {
        // Try to find it in the store first
        const storedPodcast = podcastStore.podcasts.find(
            (p) => p.id === decoded.podcastId
        );

        if (storedPodcast) {
          // Populate the podcast object with the stored data
          console.log(storedPodcast);
          podcast.value = {
            id: storedPodcast.id || "",
            title: storedPodcast.title || "",
            podcast_category_id: storedPodcast.podcastCategory?.id || "",
            author: storedPodcast.author || "",
            description: storedPodcast.description || "",
            media_item_id: storedPodcast.thumbnail?.id || "",
            file: storedPodcast.audio || "", // set preview if you store audio URL
            author_id: storedPodcast.author?.id || "",
          };

          // set image preview if media item exists
          if (storedPodcast.thumbnail?.url) {
            imagePreviewUrl.value = storedPodcast.thumbnail.url;
          }
        } else {
          console.warn(
              `Podcast with ID ${decoded.podcastId} not found in store.`
          );
        }
      } else {
        console.warn("Decoded data does not contain a podcastId field:", decoded);
      }
    } catch (error) {
      console.error("Failed to decode podcast data:", error);
    }
  }
});


</script>

<style scoped>

</style>